import { FIND_ALL_ORDERS_PAGINATION } from './../../salesOrder/graphql/queries/salesOrder.queries';
import { gql } from 'apollo-angular';

export const GET_QUOTES = gql`
  query quotes(
    $search: String 
     $status: QuoteStatus,
      # $projectId: Int, 
      $startDate: DateTime, $endDate: DateTime
  ) {
    quotes(
      search: $search 
      status: $status, 
      # projectId: $projectId, 
      startDate: $startDate, endDate: $endDate
    ) {
      id
      branchId
      quoteCode
      totalAmount
      quoteDate
      quoteStatus
      status
      projectName
      branchData {
        id
        branchName
      }
      leadId
      leadData {
        id
        branchID
      }
      customerId
      customerData {
        id
        firstName
        lastName
        email
      }
    }
  }
`;

export const FIND_ALL_QUOTES_PAGINATION = gql`
  query findAllQuotesWithPagination(
    $input: QuotePaginationInput
  ) {
    findAllQuotesWithPagination(
      input: $input
    ) {
      quotes {
      id
      branchId
      leadId
      customerId
      customerData {
        firstName
        lastName
      }
      quoteCode
      projectName
      version
      validUntil
      quoteDate
      subTotal
      tax
      discount
      totalAmount
      quoteStatus
      discountType
      discountValue
      discountReason
      isDiscountApproved
      paymentTerms
      approvalDate
      status
      createdAt
      updatedAt
    }
    total
    skip
    limit
    }
  }
`;

export const GET_QUOTE_SUMMARY = gql`
  query getQuoteOverview($startDate: DateTime, $endDate: DateTime) {
    getQuoteOverview(startDate: $startDate, endDate: $endDate) {
      totalQuotes
      draftQuotes
      pendingQuotes
      approvedQuotes
      acceptedQuotes
    }
  }
`;

export const GET_LEADS = gql`
  query leadsDropDown($search: String, $leadStatus: LeadStatus) {
    leadsDropDown(search: $search, leadStatus: $leadStatus) {
      id
      leadName
      email
      phone
    }
  }
`;

export const GET_PARENT_QUOTES = gql`
  query quotes(
    $search: String
    $status: String
    $projectId: Int
    $startDate: DateTime
    $endDate: DateTime
  ) {
    quotes(
      search: $search
      status: $status
      projectId: $projectId
      startDate: $startDate
      endDate: $endDate
    ) {
      id
      isEditable
      parentCode
      quoteCode
      quoteDate
      partnerId
      totalAmount
      parentQuoteStatus
      partnerData {
        id
        partnerType
        customerType
        displayName
        paymentTerm
        companyName
        email
      }
      projectId
      projectData {
        id
        projectCode
        projectName
      }
      quoteData {
        id
        parentQuoteId
        quoteCode
        TRN
        SOW
        quoteDate
        expiryDate
        approvalDate
        createdBy
        createdByData {
          id
          employeeCode
          firstName
          lastName
          middleName
        }
        branchId
        branchData {
          id
          branchName
        }
        billingAddressId
        billingAddressData {
          id
          attention
          addressLine1
          addressLine2
          city
          state
          country
          pinCode
          phone
          fax
        }
        shippingAddressId
        shippingAddressData {
          id
          attention
          addressLine1
          addressLine2
          city
          state
          country
          pinCode
          phone
          fax
        }
        refNumber
        projectId
        projectData {
          id
          projectName
        }
        quoteTitle
        subTotal
        tax
        adjustment
        totalAmount
        paymentTerm
        deliveryTerm
        validity
        termsCondition
        customerNote
        additionalNote
        quoteUrl
        status
        createdAt
        updatedAt
        deletedAt
        quoteAttachment {
          id
          fileName
          fileUrl
        }
        quoteItems {
          id
          description
          quantity
          unit
          tax
          rate
          amount
          discount
        }
        quoteExclusions {
          id
          exclusion
          status
        }
        quoteTemplate {
          id
          templateName
          templateBody
        }
        quoteData {
          id
          workOrderStatus
          workOrderNo
        }
      }
    }
  }
`;

export const LIST_PROJECTS = gql`
  query listProjects($search: String) {
    listProjects(search: $search) {
      id
      projectCode
      projectName
    }
  }
`;

export const FETCH_QUOTE_WORK_SPLIT_BY_ID = gql`
  query findOneQuotesWork($id: Int!) {
    findOneQuotesWork(id: $id) {
      id
      branchCode
      quoteId
      description
      amount
    }
  }
`;

export const FETCH_QUOTE_BY_ID = gql`
  query quote($id: Int!) {
    quote(id: $id) {
      quote {
      id
      branchId
      branchData {
        id
        branchName
      }
      leadId
      leadData {
        id
        branchID
        leadName
        email
        phone
        source
      }
      customerId
      customerData {
        id
        firstName
        lastName
        email
        address
      }
      quoteItems {
      id
      quoteId
      quantity
      unit
      rate
      amount
      serviceId
      serviceData{
        serviceName
        serviceTasks{
          id
          serviceId
        }
      }
      quoteServiceTasks{
          price
          estimatedTime
        }
      }
      quoteDate
      quoteCode
      quoteUrl
      projectName
      version
      validUntil
      quoteDate
      subTotal
      tax
      discount
      totalAmount
      quoteStatus
      discountType
      discountValue
      discountReason
      isDiscountApproved
      isPriority
      paymentTerms
      approvalDate
      status
      notes
    }
    relatedQuotes {
      id
      leadId
      quoteCode
      quoteStatus
    }
  }
  }
`;

export const GET_PARENT_QUOTE_BY_ID = gql`
  query parentQuote($id: Int!) {
    parentQuote(id: $id) {
      id
      isEditable
      parentCode
      quoteCode
      quoteDate
      parentQuoteStatus
      partnerId
      partnerData {
        id
        partnerType
        customerType
        displayName
        paymentTerm
        companyName
        email
      }
      projectId
      projectData {
        id
        projectCode
        projectName
      }
      quoteData {
        id
        parentQuoteId
        TRN
        quoteCode
        quoteType
        SOW
        quoteDate
        expiryDate
        approvalDate
        createdBy
        createdByData {
          id
          employeeCode
          firstName
          lastName
          middleName
        }
        branchId
        branchData {
          id
          branchName
        }
        billingAddressId
        billingAddressData {
          id
          attention
          addressLine1
          addressLine2
          city
          state
          country
          pinCode
          phone
          fax
        }
        shippingAddressId
        shippingAddressData {
          id
          attention
          addressLine1
          addressLine2
          city
          state
          country
          pinCode
          phone
          fax
        }
        refNumber
        projectId
        projectData {
          id
          projectName
        }
        quoteTitle
        subTotal
        tax
        adjustment
        totalAmount
        paymentTerm
        deliveryTerm
        validity
        termsCondition
        customerNote
        additionalNote
        quoteUrl
        status
        createdAt
        updatedAt
        deletedAt
        quoteAttachment {
          id
          fileName
          fileUrl
        }
        quoteItems {
          id
          description
          quantity
          unit
          rate
          tax
          amount
          discount
        }
        quoteExclusions {
          id
          exclusion
          status
        }
        quoteTemplate {
          id
          templateName
          templateBody
        }
        quoteData {
          id
          workOrderStatus
          workOrderNo
        }
      }
    }
  }
`;

export const GENERATE_QUOTATION_PDF = gql`
  query getQuotePDF($quoteId: Int!) {
    getQuotePDF(quoteId: $quoteId)
  }
`;
